export const generateUploadProgress = ({
  bytesTransferred,
  totalBytes,
}: {
  bytesTransferred: number;
  totalBytes: number;
}): number => {
  const progress = (bytesTransferred / totalBytes) * 100;

  if (progress <= 50) {
    return 50;
  }

  if (progress <= 75) {
    return 75;
  }

  if (progress === 100) {
    return 100;
  }

  return 90;
};
